import {catchError, tap} from "rxjs/operators";
import {from, of, throwError} from "rxjs";
import {ProcessAbbyyService} from "../../core/services/process-abbyy.service";
import {NotificationService} from "@progress/kendo-angular-notification";
import {Injectable} from "@angular/core";
import {FormsService} from "../../core/services/forms.service";
import {showNotification} from "./notificaton.util";
@Injectable({ providedIn: 'root' })
export class DocumentUtil {
    constructor(private formsService: FormsService, private notificationService: NotificationService) {}
    async downloadAd(formId: any, onSuccess?: (blob: any) => void) {
      try {
        const blob = await this.formsService.downloadAD(formId);
        if (onSuccess) {
          onSuccess(blob);
        }
        return blob;
      } catch (err: any) {
        console.error(err);
        const msg =
          err?.error?.message ??
          'An Error Occurred';
        showNotification(msg, 'error', this.notificationService);
        return null;
      }
        // return this.formsService.downloadAD(formId).pipe(
        //     tap(blob => {
        //         if (onSuccess) {
        //             onSuccess(blob);
        //         }
        //     }),
        //     catchError(err => {
        //         console.error(err);
        //         const msg =
        //             err?.error?.message ??
        //             'An Error Occurred';
        //         showNotification(msg, 'error', this.notificationService);
        //         return of(null);
        //     })
        // );
    }
  async downloadPdf(abbyyFormId: any, onSuccess?: (blob: any) => void): Promise<any> {
    try {
      const blob = await this.formsService.downloadForm(abbyyFormId);
      if (onSuccess) {
        onSuccess(blob);
      }
      return blob;

    } catch (err: any) {
      console.error(err);
      const msg =
        err?.error?.message ??
        'An Error Occurred';
      showNotification(msg, 'error', this.notificationService);
      return null;
    }
  }
  // async downloadPdf(abbyyFormId: any, onSuccess?: (blob: any) => void) {
  //   return from(this.formsService.downloadForm(abbyyFormId)).pipe(
  //     tap(blob => {
  //       if (onSuccess) {
  //         onSuccess(blob);
  //       }
  //     }),
  //     catchError(err => {
  //       console.error(err);
  //
  //       const msg =
  //         err?.error?.message ??
  //         'An Error Occurred';
  //
  //       showNotification(msg, 'error', this.notificationService);
  //
  //       return of(null);
  //     })
  //   );
  // }
    async downloadPolst(formId: any, orgId: any, onSuccess?: (blob: any) => void) {
      try {
        const blob = await this.formsService.downloadPolst(formId, orgId);
        if (onSuccess) {
          onSuccess(blob);
        }
        return blob;

      } catch (err: any) {
        console.error(err);
        const msg =
          err?.error?.message ??
          'An Error Occurred';
        showNotification(msg, 'error', this.notificationService);
        return null;
      }
        // return this.formsService.downloadPolst(formId, orgId).pipe(
        //     tap(blob => {
        //         if (onSuccess) {
        //             onSuccess(blob);
        //         }
        //     }),
        //     catchError(err => {
        //         console.error(err);
        //         const msg =
        //             err?.error?.message ??
        //             'An Error Occurred';
        //         showNotification(msg, 'error', this.notificationService);
        //         return of(null);
        //     })
        // );
    }
  finishAccountReview(currentForms: any, nonCurrentForms: any, patient: any, onSuccess?: (ptForms: any) => void) {

    const isIehp = patient?.is_iehp_patient ?? false;

    const ptPolsts: any[] = [];
    const ptAds: any[] = [];

    currentForms.forEach(cf => {
      if (cf.type === 'POLST') {
        ptPolsts.push(cf);
      } else {
        ptAds.push(cf);
      }
    });

    nonCurrentForms.forEach(ncf => {
      if (ncf.type === 'POLST') {
        ptPolsts.push(ncf);
      } else {
        ptAds.push(ncf);
      }
    });

    return from(
      this.formsService.toggleActiveForms(ptPolsts, ptAds, isIehp)
    ).pipe(
      tap(ptForms => {
        showNotification('Account Reviewed!', 'success', this.notificationService);
        if (onSuccess) {
          onSuccess(ptForms);
        }
      }),
      catchError(err => {
        console.error(err);
        const msg = err?.error?.message ?? 'An Error Occurred';
        showNotification(msg, 'error', this.notificationService);
        return throwError(() => err);
      })
    );
  }
    public static openNewTab(parts): void {
        const newBlob = new Blob([parts], {type: 'application/pdf'});
        const nav = (window.navigator as any);
        if (nav && nav.msSaveOrOpenBlob) {
            nav.msSaveOrOpenBlob(newBlob, 'form.pdf');
            return;
        }
        const data = window.URL.createObjectURL(newBlob);
        const link = document.createElement('a');
        link.href = data;
        link.download = 'form.pdf';
        window.open(data, '_blank');
    }
}
